import _ from 'lodash'
import { useContext, useState } from 'react'

import { AddEditAdUnitContext } from 'features/inventory/ad-unit/contexts/AddEditAdUnitContext'
import { PageForAdUnitTransferListDTO } from 'features/inventory/api/types/pageForAdUnitTransferListDTO'
import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { pageForAdUnitTransferListFromDTO } from './api/mapper'
import { GET_PAGES_FOR_AD_UNIT_TRANSFER_LIST } from './api/query'
import { PagesForAdUnitTransferListData, PagesForAdUnitTransferListVars } from './api/types'
import {
  PageForAdUnitTransferList,
  UseGetPagesForAdUnitTransferList,
  UseGetPagesForAdUnitTransferListProps,
} from './types'

export const useGetPagesForAdUnitTransferList = ({
  domainId,
}: UseGetPagesForAdUnitTransferListProps): UseGetPagesForAdUnitTransferList => {
  const { workspaceId } = useWorkspaceParam()
  const { adUnit } = useContext(AddEditAdUnitContext)
  const [all, setAll] = useState<PageForAdUnitTransferList[]>([])

  const active: PageForAdUnitTransferList[] = adUnit?.pages ?? []

  const { isLoading: loading } = useQuery<
    PagesForAdUnitTransferListVars,
    PagesForAdUnitTransferListData
  >({
    onCompleted: async (data: PagesForAdUnitTransferListData) => {
      const {
        pages: { nodes: pages },
      } = data

      setAll(
        pages.map(
          (page: PageForAdUnitTransferListDTO): PageForAdUnitTransferList =>
            pageForAdUnitTransferListFromDTO(page),
        ),
      )
    },
    options: {
      enabled: domainId !== undefined,
    },
    query: GET_PAGES_FOR_AD_UNIT_TRANSFER_LIST,
    variables: {
      domainId,
      workspaceId,
    },
  })

  return {
    active,
    all,
    available: _.differenceBy(all, active, 'value'),
    loading,
  }
}
